import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler,
    ChartData,
    ChartOptions,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { forwardRef } from 'react';
import ResponsiveChartContainer from './ResponsiveChartContainer';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler
);

export interface LineChartProps {
    data: ChartData<'line'>;
    options?: ChartOptions<'line'>;
    testId?: string;
    fixedHeight?: boolean;
    minHeight?: number;
    maxHeight?: number;
    heightPx?: number;
}

const LineChart = forwardRef<ChartJS<'line'> | undefined, LineChartProps>(
    function LineChart(
        {
            data,
            options,
            testId,
            fixedHeight = true,
            minHeight = 300,
            maxHeight = 700,
            heightPx = 500,
        },
        ref
    ) {
        const chartOptions = {
            ...options,
            maintainAspectRatio: false,
        };

        if (fixedHeight) {
            return (
                <div className="w-full" style={{ height: `${heightPx}px` }}>
                    <Line
                        ref={ref}
                        data={data}
                        options={chartOptions}
                        data-testid={testId ?? 'line-chart'}
                    />
                </div>
            );
        }

        return (
            <ResponsiveChartContainer
                minHeight={minHeight}
                maxHeight={maxHeight}
                testId={`${testId ?? 'line-chart'}-container`}
            >
                <Line
                    ref={ref}
                    data={data}
                    options={chartOptions}
                    data-testid={testId ?? 'line-chart'}
                />
            </ResponsiveChartContainer>
        );
    }
);

export default LineChart;
